var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganizeUniversal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105.857,
    height: 174.45,
    viewBox: "0 0 105.857 174.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6661",
    "data-name": "Rectangle 6661",
    width: 105.857,
    height: 174.45,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11557",
    "data-name": "Group 11557",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11556",
    "data-name": "Group 11556",
    transform: "translate(0 0.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65893",
    "data-name": "Path 65893",
    d: "M36.321,6.709l-1.5.615A12.129,12.129,0,0,0,32.173,4.6l.65-1.556a1.079,1.079,0,0,0-.58-1.411L28.835.209a1.079,1.079,0,0,0-1.411.58L26.8,2.284A12.246,12.246,0,0,0,23,2.23L22.357.673A1.079,1.079,0,0,0,20.95.086l-3.416,1.4A1.079,1.079,0,0,0,16.945,2.9l.617,1.5a12.235,12.235,0,0,0-2.727,2.647L13.279,6.4a1.08,1.08,0,0,0-1.411.58l-1.422,3.408a1.08,1.08,0,0,0,.58,1.411l1.5.626a12.113,12.113,0,0,0-.057,3.8l-1.554.639a1.079,1.079,0,0,0-.59,1.4l1.4,3.414a1.079,1.079,0,0,0,1.407.59l1.5-.617a12.008,12.008,0,0,0,2.648,2.727l-.65,1.557a1.079,1.079,0,0,0,.58,1.411l3.408,1.422a1.079,1.079,0,0,0,1.411-.58l.623-1.5a12.219,12.219,0,0,0,3.8.057l.639,1.554a1.079,1.079,0,0,0,1.408.588l3.415-1.4a1.079,1.079,0,0,0,.588-1.408l-.615-1.5a12.078,12.078,0,0,0,2.727-2.648l1.556.649a1.08,1.08,0,0,0,1.411-.58L39.008,18.6a1.078,1.078,0,0,0-.579-1.41h0l-1.5-.625a12.118,12.118,0,0,0,.06-3.8l1.552-.638a1.079,1.079,0,0,0,.6-1.4L37.73,7.3a1.079,1.079,0,0,0-1.408-.588M27.339,20.844a6.872,6.872,0,1,1,3.744-8.969h0a6.871,6.871,0,0,1-3.744,8.968h0",
    transform: "translate(-8.698 -0.004)",
    fill: "#e6ecfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65894",
    "data-name": "Path 65894",
    d: "M237.844,159.746l5.9,47.3a2.143,2.143,0,0,1-1.858,2.393l-48.021,5.991a2.144,2.144,0,0,1-2.393-1.858l-7.617-61a2.144,2.144,0,0,1,1.862-2.393l34.334-4.284Z",
    transform: "translate(-156.087 -123.873)",
    fill: "#bab9ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65895",
    "data-name": "Path 65895",
    d: "M252.98,140.078l5.8,47.028a2.137,2.137,0,0,1-1.847,2.382l-47.67,6.02a2.122,2.122,0,0,1-2.373-1.844l-7.475-60.647a2.137,2.137,0,0,1,1.847-2.382l34.077-4.3Z",
    transform: "translate(-169.293 -107.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65896",
    "data-name": "Path 65896",
    d: "M254.185,138.752l5.9,47.3a2.143,2.143,0,0,1-1.858,2.393l-48.021,5.991a2.144,2.144,0,0,1-2.393-1.858l-7.611-61a2.144,2.144,0,0,1,1.858-2.393l34.328-4.284Z",
    transform: "translate(-169.966 -106.048)",
    fill: "none",
    stroke: "#e6ecfa",
    strokeWidth: 1.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65897",
    "data-name": "Path 65897",
    d: "M441.991,140.742l15.821-1.974-17.795-13.843Z",
    transform: "translate(-373.591 -106.067)",
    fill: "#e6ecfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6649",
    "data-name": "Rectangle 6649",
    width: 34.847,
    height: 2.607,
    transform: "translate(43.572 61.511) rotate(-7.112)",
    fill: "#e6ecfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6650",
    "data-name": "Rectangle 6650",
    width: 34.847,
    height: 2.607,
    transform: "translate(44.481 68.794) rotate(-7.112)",
    fill: "#e6ecfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6651",
    "data-name": "Rectangle 6651",
    width: 34.847,
    height: 2.607,
    transform: "translate(45.39 76.078) rotate(-7.112)",
    fill: "#e6ecfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65898",
    "data-name": "Path 65898",
    d: "M171.382,263.764l-31.734,3.962a1.433,1.433,0,0,1-1.6-1.239l-1.273-10.22a1.438,1.438,0,0,1,1.244-1.6l31.733-3.963a1.433,1.433,0,0,1,1.6,1.239l1.273,10.21a1.433,1.433,0,0,1-1.24,1.6",
    transform: "translate(-116.118 -212.849)",
    fill: "#cd665c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65899",
    "data-name": "Path 65899",
    d: "M202.717,293.852a1.853,1.853,0,0,1-.677.823,2.726,2.726,0,0,1-1.251.436l-.946.118.28,2.249-1.526.191-.782-6.264,2.472-.309a2.839,2.839,0,0,1,1.3.1,1.784,1.784,0,0,1,.866.617,2.089,2.089,0,0,1,.389,1.011,2.039,2.039,0,0,1-.126,1.026m-1.57-.225a.9.9,0,0,0-.145-1.16.919.919,0,0,0-.677-.125l-.833.107.2,1.57.834-.107a.917.917,0,0,0,.625-.286",
    transform: "translate(-167.953 -247.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65900",
    "data-name": "Path 65900",
    d: "M238.813,286.738a2.827,2.827,0,0,1,1.282.959,3.52,3.52,0,0,1,.409,3.272,2.8,2.8,0,0,1-1.012,1.25,3.676,3.676,0,0,1-1.677.609l-2.351.292-.782-6.266,2.351-.292a3.676,3.676,0,0,1,1.782.176m.026,4.138a1.805,1.805,0,0,0,.317-1.4,1.686,1.686,0,0,0-2.061-1.6l-.722.09.458,3.641.722-.09a1.861,1.861,0,0,0,1.288-.642",
    transform: "translate(-199.253 -243.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65901",
    "data-name": "Path 65901",
    d: "M281.755,280l.152,1.223-2.552.319.165,1.317,1.91-.238.148,1.19-1.909.239.314,2.533-1.525.19-.782-6.267Z",
    transform: "translate(-235.758 -237.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65902",
    "data-name": "Path 65902",
    d: "M183.773,513.394h59.909a4.387,4.387,0,0,1,4.45,4.872l-7.932,87.2a5.463,5.463,0,0,1-5.337,4.875H192.591a5.463,5.463,0,0,1-5.337-4.875l-7.932-87.2a4.387,4.387,0,0,1,4.451-4.872",
    transform: "translate(-152.235 -435.892)",
    fill: "#dde8f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6652",
    "data-name": "Rectangle 6652",
    d: "M3.388,0H85.34a3.388,3.388,0,0,1,3.388,3.388v0A3.388,3.388,0,0,1,85.34,6.776H3.388A3.388,3.388,0,0,1,0,3.388v0A3.388,3.388,0,0,1,3.388,0Z",
    transform: "translate(17.129 77.502)",
    fill: "#9eb1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6653",
    "data-name": "Rectangle 6653",
    d: "M3.633,0h0A3.633,3.633,0,0,1,7.266,3.633V76.169A3.633,3.633,0,0,1,3.633,79.8h0A3.633,3.633,0,0,1,0,76.168V3.633A3.633,3.633,0,0,1,3.633,0Z",
    transform: "translate(57.86 90.249)",
    fill: "#9eb1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65903",
    "data-name": "Path 65903",
    d: "M239.516,600.88a2.635,2.635,0,0,1,2.386-2.859l1.993-.178a2.633,2.633,0,0,1,2.859,2.386l6.69,74.236a2.635,2.635,0,0,1-2.386,2.859l-1.993.178a2.629,2.629,0,0,1-2.856-2.386Z",
    transform: "translate(-203.35 -507.583)",
    fill: "#9eb1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65904",
    "data-name": "Path 65904",
    d: "M33.4,728.976c3.008-16.689,15.35-32.561,15.35-32.561l4.407.794c7.5,1.354,10.822,17.77,7.413,36.668S48.314,767,40.81,765.644l-4.407-.8s-5.985-19.359-3.005-35.87",
    transform: "translate(-27.649 -591.283)",
    fill: "#889eb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65905",
    "data-name": "Path 65905",
    d: "M1.341,727.681c3.407-18.9,12.253-33.12,19.758-31.767s10.822,17.77,7.413,36.668S16.258,765.7,8.753,764.345s-10.822-17.767-7.413-36.665",
    transform: "translate(0 -590.782)",
    fill: "#dde8f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65906",
    "data-name": "Path 65906",
    d: "M7.408,819.315a10.819,10.819,0,0,0,8.52,12.709l1.006.2.82-4.144-1.006-.2a6.594,6.594,0,0,1-5.2-7.748l3.355-16.944A6.6,6.6,0,0,1,22.664,798l1.007.2.82-4.141-1.009-.2a10.818,10.818,0,0,0-12.718,8.505Z",
    transform: "translate(-6.114 -673.845)",
    fill: "#889eb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65907",
    "data-name": "Path 65907",
    d: "M134.249,991.326a1.834,1.834,0,0,0-1.913-1.745H90.68a1.834,1.834,0,0,0-1.913,1.745v21.551a1.834,1.834,0,0,0,1.913,1.745h41.657a1.834,1.834,0,0,0,1.913-1.745Z",
    transform: "translate(-75.367 -840.193)",
    fill: "#c77523"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65908",
    "data-name": "Path 65908",
    d: "M112.775,948.571a2.908,2.908,0,0,0-3.032-2.766H91.8a2.908,2.908,0,0,0-3.032,2.766v7.684a2.909,2.909,0,0,0,3.032,2.767h17.942a2.909,2.909,0,0,0,3.032-2.767Z",
    transform: "translate(-75.367 -803.025)",
    fill: "#c77523"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6654",
    "data-name": "Rectangle 6654",
    width: 33.173,
    height: 41.486,
    transform: "translate(19.556 132.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65909",
    "data-name": "Path 65909",
    d: "M128.561,879.569l33.173.01a.157.157,0,0,1,.169.14L161.89,921.1a.157.157,0,0,1-.17.14l-33.173-.01a.157.157,0,0,1-.17-.14l.013-41.379a.157.157,0,0,1,.17-.14m.169.28-.013,41.1,32.835.01.013-41.1Z",
    transform: "translate(-108.998 -746.788)",
    fill: "#77aee3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6655",
    "data-name": "Rectangle 6655",
    width: 33.173,
    height: 3.666,
    transform: "translate(19.555 140.156)",
    fill: "#77aee3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65910",
    "data-name": "Path 65910",
    d: "M141.75,897.815a.281.281,0,0,1,.286-.276h9.446a.281.281,0,0,1,.286.276v.465a.281.281,0,0,1-.286.276h-9.446a.281.281,0,0,1-.286-.276Z",
    transform: "translate(-120.351 -762.045)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65911",
    "data-name": "Path 65911",
    d: "M141.75,910.8a.282.282,0,0,1,.286-.276h15.021a.281.281,0,0,1,.286.276v.465a.281.281,0,0,1-.286.276H142.036a.281.281,0,0,1-.286-.276Z",
    transform: "translate(-120.351 -773.073)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6656",
    "data-name": "Rectangle 6656",
    width: 28.276,
    height: 20.834,
    transform: "translate(22.004 148.114)",
    fill: "#e9f4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6657",
    "data-name": "Rectangle 6657",
    width: 28.276,
    height: 2.588,
    transform: "translate(22.004 148.114)",
    fill: "#bbdbfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65912",
    "data-name": "Path 65912",
    d: "M151.782,1019.966a.28.28,0,0,1,.286-.276h6.78a.28.28,0,0,1,.286.276v.465a.28.28,0,0,1-.286.276h-6.78a.28.28,0,0,1-.286-.276Z",
    transform: "translate(-128.869 -865.756)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65913",
    "data-name": "Path 65913",
    d: "M151.782,1041.058a.281.281,0,0,1,.286-.276h6.78a.281.281,0,0,1,.286.276v.465a.28.28,0,0,1-.286.275h-6.78a.28.28,0,0,1-.286-.275Z",
    transform: "translate(-128.869 -883.664)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65914",
    "data-name": "Path 65914",
    d: "M151.782,1058.014a.28.28,0,0,1,.286-.276h5.71a.281.281,0,0,1,.286.276v.465a.281.281,0,0,1-.286.276h-5.71a.28.28,0,0,1-.286-.276Z",
    transform: "translate(-128.869 -898.06)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65915",
    "data-name": "Path 65915",
    d: "M151.782,1074.135a.281.281,0,0,1,.286-.276h3.886a.281.281,0,0,1,.286.276v.465a.28.28,0,0,1-.286.275h-3.886a.28.28,0,0,1-.286-.275Z",
    transform: "translate(-128.869 -911.748)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65916",
    "data-name": "Path 65916",
    d: "M204.018,1019.966a.281.281,0,0,1,.286-.276h4.107a.281.281,0,0,1,.286.276v.465a.281.281,0,0,1-.286.276H204.3a.281.281,0,0,1-.286-.276Z",
    transform: "translate(-173.219 -865.756)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65917",
    "data-name": "Path 65917",
    d: "M289.494,1019.966a.281.281,0,0,1,.286-.276h4.107a.281.281,0,0,1,.286.276v.465a.281.281,0,0,1-.286.276H289.78a.281.281,0,0,1-.286-.276Z",
    transform: "translate(-245.791 -865.756)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65918",
    "data-name": "Path 65918",
    d: "M290.2,1058.014a.281.281,0,0,1,.287-.276H294.6a.281.281,0,0,1,.286.276v.465a.281.281,0,0,1-.286.276h-4.106a.281.281,0,0,1-.287-.276Z",
    transform: "translate(-246.395 -898.06)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65919",
    "data-name": "Path 65919",
    d: "M289.494,1037.691a.281.281,0,0,1,.286-.276h4.107a.281.281,0,0,1,.286.276v.465a.28.28,0,0,1-.286.275H289.78a.28.28,0,0,1-.286-.275Z",
    transform: "translate(-245.791 -880.805)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65920",
    "data-name": "Path 65920",
    d: "M289.494,1074.135a.281.281,0,0,1,.286-.276h4.107a.281.281,0,0,1,.286.276v.465a.28.28,0,0,1-.286.275H289.78a.28.28,0,0,1-.286-.275Z",
    transform: "translate(-245.791 -911.748)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65921",
    "data-name": "Path 65921",
    d: "M244.058,1133.254a.281.281,0,0,1,.286-.275h5.662a.281.281,0,0,1,.286.275v.465a.281.281,0,0,1-.286.276h-5.662a.28.28,0,0,1-.286-.276Z",
    transform: "translate(-207.215 -961.943)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65922",
    "data-name": "Path 65922",
    d: "M300.548,1133.254a.281.281,0,0,1,.286-.275h4.337a.281.281,0,0,1,.286.275v.465a.28.28,0,0,1-.286.276h-4.337a.281.281,0,0,1-.286-.276Z",
    transform: "translate(-255.177 -961.943)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65923",
    "data-name": "Path 65923",
    d: "M222.724,1041.058a.281.281,0,0,1,.286-.276h1.283a.281.281,0,0,1,.286.276v.465a.28.28,0,0,1-.286.275H223.01a.28.28,0,0,1-.286-.275Z",
    transform: "translate(-189.101 -883.664)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65924",
    "data-name": "Path 65924",
    d: "M252.421,1019.966a.28.28,0,0,1,.286-.276h1.283a.281.281,0,0,1,.286.276v.465a.281.281,0,0,1-.286.276h-1.283a.28.28,0,0,1-.286-.276Z",
    transform: "translate(-214.315 -865.756)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65925",
    "data-name": "Path 65925",
    d: "M219.833,1058.014a.281.281,0,0,1,.286-.276h1.719a.28.28,0,0,1,.286.276v.465a.28.28,0,0,1-.286.276h-1.719a.281.281,0,0,1-.286-.276Z",
    transform: "translate(-186.647 -898.06)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65926",
    "data-name": "Path 65926",
    d: "M222.724,1074.135a.281.281,0,0,1,.286-.276h1.283a.281.281,0,0,1,.286.276v.465a.28.28,0,0,1-.286.275H223.01a.28.28,0,0,1-.286-.275Z",
    transform: "translate(-189.101 -911.748)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65927",
    "data-name": "Path 65927",
    d: "M252.421,1058.014a.28.28,0,0,1,.286-.276h1.283a.281.281,0,0,1,.286.276v.465a.28.28,0,0,1-.286.276h-1.283a.28.28,0,0,1-.286-.276Z",
    transform: "translate(-214.315 -898.06)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65928",
    "data-name": "Path 65928",
    d: "M202.407,1041.058a.281.281,0,0,1,.286-.276h2.059a.281.281,0,0,1,.286.276v.465a.281.281,0,0,1-.286.275h-2.059a.281.281,0,0,1-.286-.275Z",
    transform: "translate(-171.851 -883.664)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65929",
    "data-name": "Path 65929",
    d: "M195.6,1058.014a.281.281,0,0,1,.286-.276h2.373a.281.281,0,0,1,.286.276v.465a.28.28,0,0,1-.286.276h-2.373a.28.28,0,0,1-.286-.276Z",
    transform: "translate(-166.074 -898.06)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65930",
    "data-name": "Path 65930",
    d: "M248.807,1037.691a.281.281,0,0,1,.286-.276h2.373a.281.281,0,0,1,.286.276v.465a.28.28,0,0,1-.286.275h-2.373a.28.28,0,0,1-.286-.275Z",
    transform: "translate(-211.247 -880.805)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65931",
    "data-name": "Path 65931",
    d: "M248.807,1074.135a.281.281,0,0,1,.286-.276h2.373a.281.281,0,0,1,.286.276v.465a.28.28,0,0,1-.286.275h-2.373a.28.28,0,0,1-.286-.275Z",
    transform: "translate(-211.247 -911.748)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65932",
    "data-name": "Path 65932",
    d: "M185.434,1074.135a.281.281,0,0,1,.286-.276h4.622a.281.281,0,0,1,.286.276v.465a.281.281,0,0,1-.286.275H185.72a.28.28,0,0,1-.286-.275Z",
    transform: "translate(-157.441 -911.748)",
    fill: "#90aecc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6658",
    "data-name": "Rectangle 6658",
    width: 0.142,
    height: 16.332,
    transform: "translate(36.142 152.019)",
    fill: "#c8def4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6659",
    "data-name": "Rectangle 6659",
    width: 0.142,
    height: 16.332,
    transform: "translate(41.812 152.019)",
    fill: "#c8def4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65933",
    "data-name": "Path 65933",
    d: "M88.767,975.6a1.912,1.912,0,0,1,1.913-1.911h41.657a1.912,1.912,0,0,1,1.913,1.911v23.617a1.912,1.912,0,0,1-1.913,1.913H90.68a1.912,1.912,0,0,1-1.913-1.913Z",
    transform: "translate(-75.367 -826.7)",
    fill: "#eb8926"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6660",
    "data-name": "Rectangle 6660",
    width: 24.007,
    height: 14.484,
    rx: 7.242,
    transform: "translate(34.876 139.748)",
    fill: "#eb8926"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizeUniversal);
export default __webpack_public_path__ + "static/media/organize-universal.772a8b691440840446c17cb91794f3c1.svg";
export { ForwardRef as ReactComponent };